export enum SortDirectionEnum {
	ASC = 'asc',
	DESC = 'desc'
}

export const SORT_TOKEN_SEPARATOR = ',';
export const SORT_DIRECTION_SEPARATOR = ':';
